module.exports = __webpack_public_path__ + "img/team-1.db92b880.png";